import doRequest from "../helpers";
import { getToken } from "services/auth/tokenAuth";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
import { currentUserLocalStorage, getUserId } from "services/storage/general";
import { wait } from "utils/others";

export const requestGetStudentsAcadReinforceReservation = async () => {
	const acadReinforceDataToAttendance =
		acadReinforcementSessionStorage.acadReinforceDataToAttendance.get();
	if (!acadReinforceDataToAttendance) return null;
	const [result, err] = await doRequest(
		`/AlumnosEnReservaRefuerzo/${acadReinforceDataToAttendance.id}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listaAlumnos.map(
		({
			codigoAlumno: id,
			idReserva: reservationId,
			nombres: name,
			asistencia: attendance,
		}) => {
			return {
				reservationId,
				id,
				name,
				attendance,
			};
		}
	);
};
export const requestAddStudentToAcadReinforceReservation = async ({
	studentId,
	acadReinforceId,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRefuerzoAcademico/Crear",
		"POST",
		{
			codigoUsuario: getUserId(),
			codigoAlumno: studentId,
			idTallerVirtual: acadReinforceId,
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			message: null,
		};
	const { data } = result;
	if (data?.state !== 1)
		return {
			success: false,
			message: null,
		};
	const { exito, mensaje } = data.data;
	return {
		success: exito,
		message: mensaje || null,
	};
};
export const requestSaveAcadReinforceAttendanceStudent = async (
	studentAttendance = []
) => {
	const currentUser = currentUserLocalStorage.get();
    const [result, err] = await doRequest(
        "/GuardarAsistenciaRefuerzoAcademico",
        "POST",
        {
            usuarioCreacion: currentUser.id,
            alumnoReservas: studentAttendance.map(
                ({ reservationId: idReserva, attendance: asistencia }) => {
                    return {
                        idReserva,
                        asistencia,
                    };
                }
            ),
        },
        getToken()
    );

    if (err) {
        return {
            success: false,
            message: "Error en la solicitud al servidor.",
        };
    }

    const { data } = result;

    // Validar el estado de la respuesta
    if (data?.state === 0) {
        return {
            success: false,
            message: data?.msg || "No se pudo guardar la asistencia.",
        };
    }

    if (data?.state === 1) {
        return {
            success: true,
            message: data?.msg || "Asistencia guardada correctamente.",
            data: data?.data || null,
        };
    }

    // Respuesta inesperada
    return {
        success: false,
        message: "Respuesta inesperada del servidor.",
    };
};

export const requestTakeTutorAttendance = async ({
	acadReinforceId,
	isCheckIn,
}) => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademico/TomarAsistenciaTutor",
		"POST",
		{
			idTallerVirtual: acadReinforceId,
			esEntrada: isCheckIn,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};
export const requestGetInfoTutorAttendance = async acadReinforceId => {
	const [result, err] = await doRequest(
		`/RefuerzoAcademico/LeerAsistenciaTutor/${acadReinforceId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const { horaEntrada, horaSalida, minutosTranscurridos } =
		data.data.leerAsistenciaRefuerzoBE;
	return {
		checkInTime: horaEntrada,
		checkOutTime: horaSalida,
		classTime: minutosTranscurridos,
	};
};
